(function () {
  'use strict';

  const step1Sections = document.querySelectorAll('[data-configurator-step="1"]');
  if (!step1Sections.length) return;

  const updateUrl = (variantId) => {
    if (!variantId) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  };

  const formatDollarsNoDecimals = (value) => {
    const rounded = Math.round(Number(value) || 0);
    return `$${rounded.toLocaleString('en-US')}`;
  };

  const dispatchVariantChange = (variantId, price) => {
    document.dispatchEvent(
      new CustomEvent('variant:changed', {
        detail: { variantId, price }
      })
    );
  };

  const bindSection = (section) => {
    const cards = section.querySelectorAll('[data-variant-card]');
    const radios = section.querySelectorAll('input[type="radio"][name="variant-selection"]');
    const titleDisplay = section.querySelector('[data-product-title-display]');
    const priceDisplay = section.querySelector('[data-product-price]');
    const comparePriceDisplay = section.querySelector('[data-compare-price]');
    const shellPriceDisplay = section.querySelector('[data-shell-price]');
    const monthlyPriceDisplays = section.querySelectorAll('[data-financing-monthly-price]');
    const thumbnails = section.querySelectorAll('[data-product-thumbnail]');
    const mainImage = section.querySelector('[data-product-main-image]');

    const selectCard = (card) => {
      cards.forEach((item) => item.classList.remove('selected'));
      card.classList.add('selected');

      const radio = card.querySelector('input[type="radio"]');
      if (radio && !radio.checked) radio.checked = true;

      const {
        variantId,
        variantPriceFormatted,
        variantShellPriceFormatted,
        variantPrice,
        variantCompareAtPrice,
        variantDisplayName
      } = card.dataset;

      if (titleDisplay && variantDisplayName) {
        titleDisplay.textContent = variantDisplayName;
      }

      if (priceDisplay && variantPriceFormatted) {
        priceDisplay.textContent = variantPriceFormatted;
      }

      if (comparePriceDisplay) {
        if (variantCompareAtPrice) {
          comparePriceDisplay.textContent = variantCompareAtPrice;
          comparePriceDisplay.style.display = '';
        } else {
          comparePriceDisplay.style.display = 'none';
        }
      }

      if (shellPriceDisplay && variantShellPriceFormatted) {
        shellPriceDisplay.textContent = variantShellPriceFormatted;
      }

      if (monthlyPriceDisplays.length) {
        const variantPriceDollars = parseFloat(variantPrice);
        if (Number.isFinite(variantPriceDollars)) {
          const monthlyPrice = formatDollarsNoDecimals(variantPriceDollars / 180);
          monthlyPriceDisplays.forEach((el) => {
            el.textContent = monthlyPrice;
          });
        }
      }

      updateUrl(variantId);
      dispatchVariantChange(variantId, parseFloat(variantPrice) || 0);
    };

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.type === 'radio') return;
        selectCard(card);
      });
    });

    radios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        if (!event.target.checked) return;
        const card = event.target.closest('[data-variant-card]');
        if (card) selectCard(card);
      });
    });

    if (thumbnails.length && mainImage) {
      thumbnails.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbnails.forEach((item) => item.classList.remove('active'));
          thumb.classList.add('active');
          const newSrc = thumb.dataset.mediaSrc;
          if (newSrc) mainImage.src = newSrc;
        });
      });
    }
  };

  step1Sections.forEach(bindSection);
})();
